var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_32_4",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 32 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7637",
    "data-name": "\\u30D1\\u30B9 7637",
    d: "M924.5,371.925H910.238a1.37,1.37,0,0,0-1.369,1.369v14.262a1.371,1.371,0,0,0,1.369,1.37H924.5a1.371,1.371,0,0,0,1.37-1.37V373.294A1.37,1.37,0,0,0,924.5,371.925Zm-.047,1.369V381.4l-2.934-2.933a.419.419,0,0,0-.594,0l-4.91,4.912-2.72-2.72a.417.417,0,0,0-.592,0l-2.432,2.431-.032-9.75Z",
    transform: "translate(-908.869 -371.925)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7638",
    "data-name": "\\u30D1\\u30B9 7638",
    d: "M913.133,378.014a1.752,1.752,0,1,0-1.752-1.752A1.755,1.755,0,0,0,913.133,378.014Z",
    transform: "translate(-907.822 -370.848)",
    fill: "#ccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.a87eac8f7a2d61d2b9bfbb18b826b01e.svg";
export { ForwardRef as ReactComponent };